import { render } from "./SegmentHome.vue?vue&type=template&id=522b336a&lang=pug"
import script from "./SegmentHome.vue?vue&type=script&lang=js"
export * from "./SegmentHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__